import { isVideo } from '../../utils/is-video';
import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';

type Props = {
  url: string;
  className?: string;
  style?: React.CSSProperties;
  isActive?: boolean;
};

export default function Slide({ url, className, style, isActive = true }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  // Set video volume when video element is available
  useEffect(() => {
    const video = videoRef.current;
    if (video && isVideo(url)) {
      video.volume = 0.5;
    }
  }, [url]);

  // Handle video play/pause based on slide visibility
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !isVideo(url)) return;

    if (isActive) {
      video.play().catch((error) => {
        console.log('Video play failed:', error);
      });
    } else {
      video.pause();
    }
  }, [isActive, url]);

  return (
    <>
      {isVideo(url) ? (
        <Box
          className={className}
          component="video"
          src={url}
          loop
          playsInline
          width="100%"
          height="100%"
          ref={videoRef}
          sx={{
            flex: '0 0 100%',
            minWidth: 0,
            objectFit: 'contain',
            ...style,
          }}
        />
      ) : (
        <img
          src={url}
          style={{
            flex: '0 0 100%',
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            ...style,
          }}
          alt="gallery image"
        />
      )}
    </>
  );
}
